var _path, _path2, _circle, _path3, _circle2, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInspectinline = function SvgInspectinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none",
    viewBox: "0 0 19 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9945FF",
    fillOpacity: 0.3,
    stroke: "#9945FF",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M.6 3.447 5.57.687l4.969 2.76v5.481l-4.97 2.76L.6 8.929z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#200F35",
    strokeLinecap: "round",
    d: "M11.812 6.75a5.06 5.06 0 0 0-3.58 1.483"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.813,
    cy: 11.813,
    r: 4.563,
    fill: "#000",
    stroke: "#9945FF",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9945FF",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M14.625 15.75 18 19.125"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "network-inspect",
    width: 11,
    height: 11,
    x: 6,
    y: 6,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.928,
    cy: 11.813,
    r: 4.947,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#network-inspect)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9945FF",
    fillOpacity: 0.3,
    stroke: "#9945FF",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "m2.635 7.02 5.171-2.771 5.171 2.77v5.465l-5.17 2.77-5.172-2.77z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#9945FF",
    strokeWidth: 1.2,
    d: "m.563 3.375 5.062 2.813 5.063-2.813M5.625 6.188v5.062"
  })));
};
export default SvgInspectinline;